// Template Mode — Template registry (plain JS, no TypeScript annotations)

// ─── Preview screenshots — high-quality Unsplash images matching each category ───
const PREVIEWS = {
  business:  "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=85&fit=crop",
  creative:  "https://images.unsplash.com/photo-1558655146-d09347e92766?w=1200&q=85&fit=crop",
  finance:   "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1200&q=85&fit=crop",
  agency:    "https://images.unsplash.com/photo-1542744094-3a31f272c490?w=1200&q=85&fit=crop",
  rayo:      "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1200&q=85&fit=crop",
};

// ─── Template Registry ───

export const TEMPLATES = [
  {
    id: "growify",
    slug: "growify",
    name: "Growify",
    tagline: "Business consulting template with hero form, animated sections, and full pricing block",
    category: "Business",
    tags: ["business", "consulting", "services", "team", "pricing", "faq"],
    style: "Modern Business",
    tier: "free",
    techStack: "HTML5",
    previewImage: PREVIEWS.business,
    previewImages: [
      PREVIEWS.business,
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=85&fit=crop",
      "https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=1200&q=85&fit=crop",
    ],
    popularity: 1800,
    isNew: true,
    isFeatured: true,
    pageCount: 1,
    defaultBrandKit: {
      logoUrl: null,
      colors: { primary: "#a9e448", secondary: "#bccbb7", accent: "#a9e448", background: "#F7F7F2", text: "#000000" },
      fonts: { heading: "DM Sans", body: "Inter" },
    },
    pages: [
      {
        id: "growify_home",
        name: "Home",
        slug: "home",
        htmlPath: "https://assets.orbis.build/templates_vault/growify/business-consulting.html",
        sections: [
          {
            id: "header", type: "header", label: "Header",
            contentSlots: [
              { id: "company_name", key: "company_name", type: "heading", defaultValue: "Growify", aiEnhanceable: false },
              { id: "nav_home", key: "nav_home", type: "link", defaultValue: "home", aiEnhanceable: false },
              { id: "nav_about", key: "nav_about", type: "link", defaultValue: "About", aiEnhanceable: false },
              { id: "nav_services", key: "nav_services", type: "link", defaultValue: "Services", aiEnhanceable: false },
              { id: "nav_team", key: "nav_team", type: "link", defaultValue: "Team", aiEnhanceable: false },
              { id: "nav_pricing", key: "nav_pricing", type: "link", defaultValue: "Pricing", aiEnhanceable: false },
              { id: "nav_blog", key: "nav_blog", type: "link", defaultValue: "blog", aiEnhanceable: false },
              { id: "login_text", key: "login_text", type: "link", defaultValue: "Login & Register", aiEnhanceable: false },
              { id: "phone_label", key: "phone_label", type: "label", defaultValue: "Phone No:", aiEnhanceable: false },
              { id: "phone_number", key: "phone_number", type: "link", defaultValue: "(+123) 567 8910", aiEnhanceable: false },
            ],
            imageSlots: [],
          },
          {
            id: "hero", type: "hero", label: "Hero",
            contentSlots: [
              { id: "hero_headline", key: "hero_headline", type: "heading", defaultValue: "Focus on growing your business.", aiEnhanceable: true },
              { id: "hero_subtext", key: "hero_subtext", type: "body", defaultValue: "Our comprehensive office support services take care of everything from administrative tasks to technical troubleshooting.", aiEnhanceable: true },
              { id: "hero_cta", key: "hero_cta", type: "cta", defaultValue: "Get Started for Free", aiEnhanceable: false },
              { id: "hero_review_text", key: "hero_review_text", type: "body", defaultValue: "Our clients are ambitious businesses that understand the value of efficiency.", aiEnhanceable: true },
              { id: "hero_rating_text", key: "hero_rating_text", type: "body", defaultValue: "4.9 out of 5 rating", aiEnhanceable: false },
              { id: "form_title", key: "form_title", type: "heading", defaultValue: "Expert Consulting Queries & Solutions", aiEnhanceable: true },
              { id: "form_subtitle", key: "form_subtitle", type: "heading", defaultValue: "Consulting Queries?", aiEnhanceable: false },
            ],
            imageSlots: [],
          },
          {
            id: "about", type: "about", label: "About",
            contentSlots: [
              { id: "about_overline", key: "about_overline", type: "label", defaultValue: "Website that brings leads", aiEnhanceable: false },
              { id: "about_headline", key: "about_headline", type: "heading", defaultValue: "We provide comprehensive office support services that help businesses run smoothly and efficiently.", aiEnhanceable: true },
              { id: "about_subtext", key: "about_subtext", type: "body", defaultValue: "Our skilled team manages administrative tasks, technical support, and daily operations to ensure your business runs smoothly.", aiEnhanceable: true },
              { id: "mission_title", key: "mission_title", type: "heading", defaultValue: "Our Mission", aiEnhanceable: false },
              { id: "mission_text", key: "mission_text", type: "body", defaultValue: "We specialize in comprehensive financial planning and advisory services tailored to your unique goals.", aiEnhanceable: true },
              { id: "vision_title", key: "vision_title", type: "heading", defaultValue: "Our Vision", aiEnhanceable: false },
              { id: "vision_text", key: "vision_text", type: "body", defaultValue: "We help companies achieve long-term growth through strategic consulting and data-driven decisions.", aiEnhanceable: true },
              { id: "goals_title", key: "goals_title", type: "heading", defaultValue: "Our Goals", aiEnhanceable: false },
              { id: "goals_text", key: "goals_text", type: "body", defaultValue: "Deliver measurable results that transform businesses from good to exceptional.", aiEnhanceable: true },
              { id: "trusted_text", key: "trusted_text", type: "heading", defaultValue: "Trusted by 280+ professional & growing businesses", aiEnhanceable: false },
              { id: "stat_1_value", key: "stat_1_value", type: "heading", defaultValue: "25K+", aiEnhanceable: false },
              { id: "stat_1_label", key: "stat_1_label", type: "body", defaultValue: "Unique & new business tips", aiEnhanceable: false },
              { id: "stat_2_value", key: "stat_2_value", type: "heading", defaultValue: "14K+", aiEnhanceable: false },
              { id: "stat_2_label", key: "stat_2_label", type: "body", defaultValue: "Successful projects delivered", aiEnhanceable: false },
              { id: "stat_3_value", key: "stat_3_value", type: "heading", defaultValue: "31K+", aiEnhanceable: false },
              { id: "stat_3_label", key: "stat_3_label", type: "body", defaultValue: "Growth-focused solutions", aiEnhanceable: false },
            ],
            imageSlots: [],
          },
          {
            id: "services", type: "services", label: "Services",
            contentSlots: [
              { id: "services_overline", key: "services_overline", type: "label", defaultValue: "Business Services", aiEnhanceable: false },
              { id: "services_headline", key: "services_headline", type: "heading", defaultValue: "The Best Solutions for Your Business Growth", aiEnhanceable: true },
              { id: "services_subtext", key: "services_subtext", type: "body", defaultValue: "Intangible solutions designed to help companies operate smoothly, reduce costs, and improve productivity.", aiEnhanceable: true },
              { id: "service_1_title", key: "service_1_title", type: "heading", defaultValue: "Consulting Services", aiEnhanceable: true },
              { id: "service_1_desc", key: "service_1_desc", type: "body", defaultValue: "Strategic guidance to help your business achieve its goals and overcome challenges.", aiEnhanceable: true },
              { id: "service_2_title", key: "service_2_title", type: "heading", defaultValue: "Digital Marketing", aiEnhanceable: true },
              { id: "service_2_desc", key: "service_2_desc", type: "body", defaultValue: "Data-driven campaigns that generate leads and grow your online presence.", aiEnhanceable: true },
              { id: "service_3_title", key: "service_3_title", type: "heading", defaultValue: "Investment & Advisory", aiEnhanceable: true },
              { id: "service_3_desc", key: "service_3_desc", type: "body", defaultValue: "Expert financial guidance to help you make informed investment decisions.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "how_it_works", type: "how_it_works", label: "How It Works",
            contentSlots: [
              { id: "how_overline", key: "how_overline", type: "label", defaultValue: "How it Works", aiEnhanceable: false },
              { id: "how_headline", key: "how_headline", type: "heading", defaultValue: "Smooth Start, Strong Growth", aiEnhanceable: true },
              { id: "step_1_title", key: "step_1_title", type: "heading", defaultValue: "Request a Free Consultation", aiEnhanceable: true },
              { id: "step_1_desc", key: "step_1_desc", type: "body", defaultValue: "We begin with a thorough discovery session to understand your goals, challenges, and opportunities.", aiEnhanceable: true },
              { id: "step_2_title", key: "step_2_title", type: "heading", defaultValue: "Get Your Customized Plan", aiEnhanceable: true },
              { id: "step_2_desc", key: "step_2_desc", type: "body", defaultValue: "Our experts build a tailored strategy aligned with your unique business context.", aiEnhanceable: true },
              { id: "step_3_title", key: "step_3_title", type: "heading", defaultValue: "Unlock Opportunities", aiEnhanceable: true },
              { id: "step_3_desc", key: "step_3_desc", type: "body", defaultValue: "Execute the plan with our guided support to capitalize on growth opportunities.", aiEnhanceable: true },
              { id: "step_4_title", key: "step_4_title", type: "heading", defaultValue: "Scale With Confidence", aiEnhanceable: true },
              { id: "step_4_desc", key: "step_4_desc", type: "body", defaultValue: "Measure results, iterate, and scale with data-backed confidence.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "team", type: "team", label: "Team",
            contentSlots: [
              { id: "team_overline", key: "team_overline", type: "label", defaultValue: "Meet Our Team", aiEnhanceable: false },
              { id: "team_headline", key: "team_headline", type: "heading", defaultValue: "Our Leadership & Team", aiEnhanceable: true },
              { id: "team_1_role", key: "team_1_role", type: "label", defaultValue: "Expert Consultant", aiEnhanceable: false },
              { id: "team_1_name", key: "team_1_name", type: "heading", defaultValue: "Thomas Williams", aiEnhanceable: false },
              { id: "team_1_bio", key: "team_1_bio", type: "body", defaultValue: "Senior Business Consultant with over 10 years of experience in strategy and operations.", aiEnhanceable: true },
              { id: "team_2_role", key: "team_2_role", type: "label", defaultValue: "Expert Consultant", aiEnhanceable: false },
              { id: "team_2_name", key: "team_2_name", type: "heading", defaultValue: "Sarah Johnson", aiEnhanceable: false },
              { id: "team_2_bio", key: "team_2_bio", type: "body", defaultValue: "Senior Business Consultant with over 10 years of experience in strategy and operations.", aiEnhanceable: true },
              { id: "team_3_role", key: "team_3_role", type: "label", defaultValue: "Creative Director", aiEnhanceable: false },
              { id: "team_3_name", key: "team_3_name", type: "heading", defaultValue: "Sophia Martinez", aiEnhanceable: false },
              { id: "team_3_bio", key: "team_3_bio", type: "body", defaultValue: "Creative director bringing bold, brand-first thinking to every project.", aiEnhanceable: true },
              { id: "team_4_role", key: "team_4_role", type: "label", defaultValue: "Community Manager", aiEnhanceable: false },
              { id: "team_4_name", key: "team_4_name", type: "heading", defaultValue: "Olivia Harris", aiEnhanceable: false },
              { id: "team_4_bio", key: "team_4_bio", type: "body", defaultValue: "Building bridges between clients and communities that matter.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "testimonials", type: "testimonials", label: "Testimonials",
            contentSlots: [
              { id: "testimonials_overline", key: "testimonials_overline", type: "label", defaultValue: "Testimonials & Reviews", aiEnhanceable: false },
              { id: "testimonials_headline", key: "testimonials_headline", type: "heading", defaultValue: "Trusted by Leading Brands and Professionals", aiEnhanceable: true },
              { id: "testimonial_1_quote", key: "testimonial_1_quote", type: "body", defaultValue: "This company truly understands business needs. Their team provided us with expert guidance and delivered results beyond our expectations.", aiEnhanceable: true },
              { id: "testimonial_1_author", key: "testimonial_1_author", type: "heading", defaultValue: "Michael R.", aiEnhanceable: false },
              { id: "testimonial_2_quote", key: "testimonial_2_quote", type: "body", defaultValue: "This company truly understands business needs. Their team provided us with expert guidance and delivered results beyond our expectations.", aiEnhanceable: true },
              { id: "testimonial_2_author", key: "testimonial_2_author", type: "heading", defaultValue: "Daniel Benjamin", aiEnhanceable: false },
              { id: "testimonial_3_quote", key: "testimonial_3_quote", type: "body", defaultValue: "Their expertise exceeded our expectations. They helped streamline our operations and introduced practical tools that immediately boosted productivity.", aiEnhanceable: true },
              { id: "testimonial_3_author", key: "testimonial_3_author", type: "heading", defaultValue: "Samuel Christopher", aiEnhanceable: false },
            ],
            imageSlots: [],
          },
          {
            id: "faq", type: "faq", label: "FAQ",
            contentSlots: [
              { id: "faq_overline", key: "faq_overline", type: "label", defaultValue: "Questions", aiEnhanceable: false },
              { id: "faq_headline", key: "faq_headline", type: "heading", defaultValue: "Have Questions? We've Got Answers!", aiEnhanceable: true },
              { id: "faq_1_question", key: "faq_1_question", type: "heading", defaultValue: "How can business consulting help my company?", aiEnhanceable: true },
              { id: "faq_1_answer", key: "faq_1_answer", type: "body", defaultValue: "Business consulting provides expert guidance to help you identify opportunities, overcome challenges, and achieve your growth goals faster.", aiEnhanceable: true },
              { id: "faq_2_question", key: "faq_2_question", type: "heading", defaultValue: "What is your consulting process?", aiEnhanceable: true },
              { id: "faq_2_answer", key: "faq_2_answer", type: "body", defaultValue: "We start with a discovery call, build a tailored strategy, and provide ongoing support as you execute and scale.", aiEnhanceable: true },
              { id: "faq_3_question", key: "faq_3_question", type: "heading", defaultValue: "Do you work with small businesses?", aiEnhanceable: true },
              { id: "faq_3_answer", key: "faq_3_answer", type: "body", defaultValue: "Absolutely — we work with businesses of all sizes, from solo founders to enterprise teams.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "pricing", type: "pricing", label: "Pricing",
            contentSlots: [
              { id: "pricing_overline", key: "pricing_overline", type: "label", defaultValue: "Plans and Pricing", aiEnhanceable: false },
              { id: "pricing_headline", key: "pricing_headline", type: "heading", defaultValue: "Honest Pricing. No Surprises. No Credit Card Required", aiEnhanceable: true },
              { id: "pricing_plan_1_name", key: "pricing_plan_1_name", type: "heading", defaultValue: "Starter", aiEnhanceable: false },
              { id: "pricing_plan_1_price", key: "pricing_plan_1_price", type: "heading", defaultValue: "$70", aiEnhanceable: false },
              { id: "pricing_plan_1_period", key: "pricing_plan_1_period", type: "label", defaultValue: "/month", aiEnhanceable: false },
              { id: "pricing_plan_1_desc", key: "pricing_plan_1_desc", type: "body", defaultValue: "For solo consultants and small teams getting started.", aiEnhanceable: true },
              { id: "pricing_plan_2_name", key: "pricing_plan_2_name", type: "heading", defaultValue: "Professional", aiEnhanceable: false },
              { id: "pricing_plan_2_price", key: "pricing_plan_2_price", type: "heading", defaultValue: "$110", aiEnhanceable: false },
              { id: "pricing_plan_2_period", key: "pricing_plan_2_period", type: "label", defaultValue: "/month", aiEnhanceable: false },
              { id: "pricing_plan_2_desc", key: "pricing_plan_2_desc", type: "body", defaultValue: "For growing teams that need advanced consulting and reporting.", aiEnhanceable: true },
              { id: "pricing_plan_3_name", key: "pricing_plan_3_name", type: "heading", defaultValue: "Enterprise", aiEnhanceable: false },
              { id: "pricing_plan_3_price", key: "pricing_plan_3_price", type: "heading", defaultValue: "$190", aiEnhanceable: false },
              { id: "pricing_plan_3_period", key: "pricing_plan_3_period", type: "label", defaultValue: "/month", aiEnhanceable: false },
              { id: "pricing_plan_3_desc", key: "pricing_plan_3_desc", type: "body", defaultValue: "For enterprise teams scaling with dedicated support.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "footer", type: "footer", label: "Footer",
            contentSlots: [
              { id: "footer_col_1_title", key: "footer_col_1_title", type: "heading", defaultValue: "Expertise", aiEnhanceable: false },
              { id: "footer_col_2_title", key: "footer_col_2_title", type: "heading", defaultValue: "Quick Links", aiEnhanceable: false },
              { id: "footer_newsletter_text", key: "footer_newsletter_text", type: "body", defaultValue: "Get business tips, exclusive offers & more", aiEnhanceable: true },
              { id: "footer_copyright", key: "footer_copyright", type: "body", defaultValue: "Copyright © 2025 Growify. All Rights Reserved.", aiEnhanceable: true },
              { id: "footer_address", key: "footer_address", type: "body", defaultValue: "5609 E Sprague Ave, Spokane Valley, WA 99212, USA", aiEnhanceable: true },
              { id: "footer_phone", key: "footer_phone", type: "link", defaultValue: "+1-394-495-5993", aiEnhanceable: false },
              { id: "footer_email_1", key: "footer_email_1", type: "link", defaultValue: "hello@growify.com", aiEnhanceable: false },
            ],
            imageSlots: [],
          },
        ],
      },
    ],
  },

  {
    id: "hunky",
    slug: "hunky",
    name: "Hunky",
    tagline: "Creative digital agency template with bold typography and stunning portfolio showcases",
    category: "Creative",
    tags: ["creative", "agency", "portfolio", "digital", "branding"],
    style: "Bold & Modern",
    tier: "free",
    techStack: "HTML5",
    previewImage: PREVIEWS.creative,
    previewImages: [
      PREVIEWS.creative,
      "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=1200&q=85&fit=crop",
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=1200&q=85&fit=crop",
    ],
    popularity: 1500,
    isNew: true,
    isFeatured: true,
    pageCount: 1,
    defaultBrandKit: {
      logoUrl: null,
      colors: { primary: "#0e0e0e", secondary: "#f6f5f3", accent: "#88e64a", background: "#ffffff", text: "#0e0e0e" },
      fonts: { heading: "Space Grotesk", body: "Inter" },
    },
    pages: [
      {
        id: "hunky_home",
        name: "Home",
        slug: "home",
        htmlPath: "https://assets.orbis.build/templates_vault/hunky/index.html",
        sections: [
          {
            id: "header", type: "header", label: "Header",
            contentSlots: [
              { id: "header_logo", key: "header_logo", type: "image", defaultValue: "assets/img/logo.png", aiEnhanceable: false },
            ],
            imageSlots: [],
          },
          {
            id: "hero", type: "hero", label: "Hero",
            contentSlots: [
              { id: "hero_overline", key: "hero_overline", type: "label", defaultValue: "We Are A", aiEnhanceable: false },
              { id: "hero_headline", key: "hero_headline", type: "heading", defaultValue: "Creative Digital", aiEnhanceable: true },
              { id: "hero_headline_suffix", key: "hero_headline_suffix", type: "heading", defaultValue: "Agency", aiEnhanceable: true },
              { id: "hero_subtext", key: "hero_subtext", type: "body", defaultValue: "We are a digital agency that helps businesses develop immersive experiences that drive top-level growth.", aiEnhanceable: true },
              { id: "hero_cta", key: "hero_cta", type: "cta", defaultValue: "View My Works", aiEnhanceable: false },
              { id: "hero_stat_value", key: "hero_stat_value", type: "heading", defaultValue: "1800", aiEnhanceable: false },
              { id: "hero_stat_label", key: "hero_stat_label", type: "body", defaultValue: "Projects Finished", aiEnhanceable: false },
            ],
            imageSlots: [
              { id: "hero_project_images", key: "hero_project_images", label: "Hero Portrait", defaultImage: "assets/img/hero/home-1/profile-img-1.png", aspectRatio: "3/4", required: false },
            ],
          },
          {
            id: "services", type: "services", label: "Services",
            contentSlots: [
              { id: "services_overline", key: "services_overline", type: "label", defaultValue: "Our Latest Client Solutions", aiEnhanceable: false },
              { id: "service_1_title", key: "service_1_title", type: "heading", defaultValue: "Branding Design", aiEnhanceable: true },
              { id: "service_1_description", key: "service_1_description", type: "body", defaultValue: "We care about success — relationships fuel growth and we love building brands that last.", aiEnhanceable: true },
              { id: "service_2_title", key: "service_2_title", type: "heading", defaultValue: "Web Development", aiEnhanceable: true },
              { id: "service_2_description", key: "service_2_description", type: "body", defaultValue: "From pixel-perfect design to lightning-fast code — we ship products that perform.", aiEnhanceable: true },
              { id: "service_3_title", key: "service_3_title", type: "heading", defaultValue: "Digital Marketing", aiEnhanceable: true },
              { id: "service_3_description", key: "service_3_description", type: "body", defaultValue: "Data-driven campaigns that grow your audience and convert visitors into customers.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "experience", type: "about", label: "Experience",
            contentSlots: [
              { id: "experience_headline", key: "experience_headline", type: "heading", defaultValue: "Creating Quality Design Experiences", aiEnhanceable: true },
              { id: "experience_cta", key: "experience_cta", type: "cta", defaultValue: "About Us", aiEnhanceable: false },
              { id: "experience_stat_1_value", key: "experience_stat_1_value", type: "heading", defaultValue: "15+", aiEnhanceable: false },
              { id: "experience_stat_1_label", key: "experience_stat_1_label", type: "body", defaultValue: "Years of experience", aiEnhanceable: false },
              { id: "experience_stat_2_value", key: "experience_stat_2_value", type: "heading", defaultValue: "120K", aiEnhanceable: false },
              { id: "experience_stat_2_label", key: "experience_stat_2_label", type: "body", defaultValue: "Successful projects", aiEnhanceable: false },
              { id: "experience_stat_3_value", key: "experience_stat_3_value", type: "heading", defaultValue: "100%", aiEnhanceable: false },
              { id: "experience_stat_3_label", key: "experience_stat_3_label", type: "body", defaultValue: "Client satisfaction rate", aiEnhanceable: false },
            ],
            imageSlots: [
              { id: "experience_image", key: "experience_image", label: "Experience Image", defaultImage: "assets/img/experience/img-1.png", aspectRatio: "4/3", required: false },
            ],
          },
          {
            id: "projects", type: "portfolio", label: "Projects",
            contentSlots: [
              { id: "projects_overline", key: "projects_overline", type: "label", defaultValue: "Discover Our Selected Projects", aiEnhanceable: false },
            ],
            imageSlots: [
              { id: "project_1_image", key: "project_1_image", label: "Project 1", defaultImage: "assets/img/projects/home-1/img-1.png", aspectRatio: "4/3", required: false },
            ],
          },
          {
            id: "footer", type: "footer", label: "Footer",
            contentSlots: [
              { id: "footer_about", key: "footer_about", type: "body", defaultValue: "We are a digital agency that helps businesses develop immersive experiences.", aiEnhanceable: true },
              { id: "footer_copyright", key: "footer_copyright", type: "body", defaultValue: "© 2025 Hunky. All rights reserved.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
        ],
      },
    ],
  },

  {
    id: "allianz",
    slug: "allianz",
    name: "Allianz",
    tagline: "Premium financial consulting template with professional banking design and sleek animations",
    category: "Finance",
    tags: ["finance", "consulting", "banking", "investment", "wealth"],
    style: "Professional",
    tier: "free",
    techStack: "HTML5",
    previewImage: PREVIEWS.finance,
    previewImages: [
      PREVIEWS.finance,
      "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&q=85&fit=crop",
      "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=1200&q=85&fit=crop",
    ],
    popularity: 1200,
    isNew: true,
    isFeatured: false,
    pageCount: 1,
    defaultBrandKit: {
      logoUrl: null,
      colors: { primary: "#fe5b2c", secondary: "#282828", accent: "#fe5b2c", background: "#f6f6f1", text: "#1b1a1a" },
      fonts: { heading: "Playfair Display", body: "Inter" },
    },
    pages: [
      {
        id: "allianz_home",
        name: "Home",
        slug: "home",
        htmlPath: "https://assets.orbis.build/templates_vault/allianz/index.html",
        sections: [
          {
            id: "header", type: "header", label: "Header",
            contentSlots: [
              { id: "header_logo", key: "header_logo", type: "image", defaultValue: "assets/images/logo/logo-light.png", aiEnhanceable: false },
            ],
            imageSlots: [],
          },
          {
            id: "hero", type: "hero", label: "Hero",
            contentSlots: [
              { id: "hero_overline", key: "hero_overline", type: "label", defaultValue: "Take control of your financial future and start growing your wealth", aiEnhanceable: true },
              { id: "hero_headline", key: "hero_headline", type: "heading", defaultValue: "Grow Your Wealth With Our Leading Edge Solutions!", aiEnhanceable: true },
              { id: "slider_control_title", key: "slider_control_title", type: "heading", defaultValue: "Grow Your Width", aiEnhanceable: true },
              { id: "slider_control_bio", key: "slider_control_bio", type: "body", defaultValue: "We help our clients achieve their goals by providing expert consulting services.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "counters", type: "stats", label: "Stats",
            contentSlots: [
              { id: "counter_number_1", key: "counter_number_1", type: "heading", defaultValue: "6,154", aiEnhanceable: false },
              { id: "counter_desc_1", key: "counter_desc_1", type: "body", defaultValue: "Released projects and strategies planned in 2025.", aiEnhanceable: true },
              { id: "counter_number_2", key: "counter_number_2", type: "heading", defaultValue: "2,512", aiEnhanceable: false },
              { id: "counter_desc_2", key: "counter_desc_2", type: "body", defaultValue: "Qualified and dedicated team of financial experts to help you.", aiEnhanceable: true },
              { id: "counter_number_3", key: "counter_number_3", type: "heading", defaultValue: "1,784", aiEnhanceable: false },
              { id: "counter_desc_3", key: "counter_desc_3", type: "body", defaultValue: "Satisfied and happy clients we have served all over the world.", aiEnhanceable: true },
              { id: "counter_number_4", key: "counter_number_4", type: "heading", defaultValue: "29", aiEnhanceable: false },
              { id: "counter_desc_4", key: "counter_desc_4", type: "body", defaultValue: "Years of proven financial expertise in wealth management planning.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "services", type: "services", label: "Services",
            contentSlots: [
              { id: "services_overline", key: "services_overline", type: "heading", defaultValue: "We believe in a distinctive way of managing money.", aiEnhanceable: false },
              { id: "services_headline", key: "services_headline", type: "heading", defaultValue: "The best solution for future business!", aiEnhanceable: true },
              { id: "service_title_1", key: "service_title_1", type: "heading", defaultValue: "Banking & Finance", aiEnhanceable: true },
              { id: "service_desc_1", key: "service_desc_1", type: "body", defaultValue: "We help you respond innovatively to this rapidly changing financial landscape.", aiEnhanceable: true },
              { id: "service_title_2", key: "service_title_2", type: "heading", defaultValue: "Sciences & Healthcare", aiEnhanceable: true },
              { id: "service_desc_2", key: "service_desc_2", type: "body", defaultValue: "Advisory services for pharmaceutical, biotech, and healthcare organizations.", aiEnhanceable: true },
              { id: "service_title_3", key: "service_title_3", type: "heading", defaultValue: "Technology & Software", aiEnhanceable: true },
              { id: "service_desc_3", key: "service_desc_3", type: "body", defaultValue: "As AI and IoT reshape industries, we help you stay ahead of the curve.", aiEnhanceable: true },
              { id: "service_title_4", key: "service_title_4", type: "heading", defaultValue: "Education & Training", aiEnhanceable: true },
              { id: "service_desc_4", key: "service_desc_4", type: "body", defaultValue: "Education is a key driver of economic competitiveness — we help unlock it.", aiEnhanceable: true },
              { id: "service_title_5", key: "service_title_5", type: "heading", defaultValue: "Hospitality & Leisure", aiEnhanceable: true },
              { id: "service_desc_5", key: "service_desc_5", type: "body", defaultValue: "Comprehensive consulting for hospitality and tourism businesses of all scales.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "testimonials", type: "testimonials", label: "Testimonials",
            contentSlots: [
              { id: "testimonials_headline", key: "testimonials_headline", type: "heading", defaultValue: "What Our Customers Feel About Our Services!", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "blog", type: "blog", label: "Blog",
            contentSlots: [
              { id: "blog_headline", key: "blog_headline", type: "heading", defaultValue: "News & Articles", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "footer", type: "footer", label: "Footer",
            contentSlots: [
              { id: "footer_newsletter_title", key: "footer_newsletter_title", type: "heading", defaultValue: "Sign up for alerts, monthly insights, and strategic business perspectives", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
        ],
      },
    ],
  },

  {
    id: "rayo",
    slug: "rayo",
    name: "Rayo",
    tagline: "Dynamic digital agency portfolio with innovative animations and bold creative design",
    category: "Creative",
    tags: ["creative", "agency", "portfolio", "digital", "innovative", "personal"],
    style: "Modern Dynamic",
    tier: "free",
    techStack: "HTML5",
    previewImage: PREVIEWS.rayo,
    previewImages: [
      PREVIEWS.rayo,
      "https://images.unsplash.com/photo-1545239351-ef35f43d514b?w=1200&q=85&fit=crop",
      "https://images.unsplash.com/photo-1547658719-da2b51169166?w=1200&q=85&fit=crop",
    ],
    popularity: 1100,
    isNew: true,
    isFeatured: false,
    pageCount: 1,
    defaultBrandKit: {
      logoUrl: null,
      colors: { primary: "#0055DC", secondary: "#C5EBF5", accent: "#6ECCE5", background: "#ffffff", text: "#36393a" },
      fonts: { heading: "Space Grotesk", body: "Inter" },
    },
    pages: [
      {
        id: "rayo_home",
        name: "Home",
        slug: "home",
        htmlPath: "https://assets.orbis.build/templates_vault/rayo/index.html",
        sections: [
          {
            id: "header", type: "header", label: "Header",
            contentSlots: [
              { id: "page_title", key: "page_title", type: "heading", defaultValue: "Rayo - Digital Agency & Personal Portfolio", aiEnhanceable: false },
              { id: "menu_caption", key: "menu_caption", type: "body", defaultValue: "Innovative design and cutting-edge development", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "hero", type: "hero", label: "Hero",
            contentSlots: [
              { id: "hero_headline_1", key: "hero_headline_1", type: "heading", defaultValue: "Make", aiEnhanceable: true },
              { id: "hero_headline_2", key: "hero_headline_2", type: "heading", defaultValue: "your work", aiEnhanceable: true },
              { id: "hero_headline_3", key: "hero_headline_3", type: "heading", defaultValue: "stand out", aiEnhanceable: true },
              { id: "hero_description", key: "hero_description", type: "body", defaultValue: "Elevate your digital presence with Rayo — a dynamic and stylish template designed for creative agencies and personal brands.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
          {
            id: "footer", type: "footer", label: "Footer",
            contentSlots: [
              { id: "footer_about", key: "footer_about", type: "body", defaultValue: "We are a creative digital agency specializing in innovative design and cutting-edge development.", aiEnhanceable: true },
              { id: "footer_copyright", key: "footer_copyright", type: "body", defaultValue: "© 2025 Rayo. All rights reserved.", aiEnhanceable: true },
            ],
            imageSlots: [],
          },
        ],
      },
    ],
  },
];

// ─── Helper functions ───

export function getTemplateById(id) {
  return TEMPLATES.find((t) => t.id === id);
}

export function getTemplatesByCategory(category) {
  if (category === "All") return TEMPLATES;
  return TEMPLATES.filter((t) => t.category === category);
}

export function getFeaturedTemplates() {
  return TEMPLATES.filter((t) => t.isFeatured);
}

export function getAllCategories() {
  const cats = new Set(TEMPLATES.map((t) => t.category));
  return Array.from(cats);
}

export function getAllStyles() {
  const styles = new Set(TEMPLATES.map((t) => t.style));
  return Array.from(styles);
}
